import React from 'react';
import TimeEntriesList from '../../components/employee/TimeEntriesList';

const TimeEntries = () => {
  return <TimeEntriesList />;
};

export default TimeEntries;